<div class="tab-pane" role="tabpanel" id="caract_sol">
    <fieldset id="agregar_caract_sol" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <h3 class="form-signin-heading"><strong>Caracteristica de la solicitud</strong></h3>
                        <hr>
                        <div class="form-horizontal">
                            <div class="form-group" align="left" style="padding-bottom: 20px">
                                <div class="col-md-12" align="left">
                                    <h4><strong>Resoluci&oacute;n permiso</strong></h4>
                                </div>
                                <div class="col-md-2">
                                    <label for="agregar_caract_sol" style=" padding-top: 15px;">N&uacute;mero:</label>
                                </div>
                                <div class="col-md-10">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Nº" id="num_reso_perm" name="num_reso_perm" formControlName="num_reso_perm" (change)="add_caract_sol()">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2">
                                    <label class="control-label" for="fecha" style="padding-bottom: 20px; padding-top: 15px;">Fecha:</label>
                                </div>
                                <div class="col-md-10">
                                    <mat-form-field class="dateinput" style="width: 145px;">
                                        <input matInput [matDatepicker]="dp4" [max]="maxDate" formControlName="fecha_reso_perm" disabled (dateInput)="add_caract_sol($event, 'input')" (dateChange)="add_caract_sol($event, 'change')">
                                        <mat-datepicker-toggle matSuffix [for]="dp4"></mat-datepicker-toggle>
                                        <mat-datepicker #dp4 disabled="false"></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div>
                        <div>
                            <div class="col-md-2" style="padding-left: 0px">
                                <label for="tipo_garantia" >Tipo Garant&iacute;a</label>
                            </div>
                            <div class="col-sm-10" class="inline" style="font-size: 13px">
                                <div class="col-md-10">
                                    <mat-checkbox  [(ngModel)]="tipo_garantia['GARANTÍA PARCIAL']" value="1" (change)="add_caract_sol()">GARANTÍA PARCIAL</mat-checkbox>
                                </div>
                                <div class="col-md-2"></div>
                                <div class="col-md-10">
                                    <mat-checkbox  [(ngModel)]="tipo_garantia['GARANTÍA TOTAL']" value="2" (change)="add_caract_sol()">GARANTÍA TOTAL</mat-checkbox>
                                </div>
                                <div class="col-md-2"></div>
                                <div class="col-md-10" *ngIf="encontrado != '4.5'">
                                    <mat-checkbox  [(ngModel)]="tipo_garantia['VIALIDAD']"value="3" (change)="add_caract_sol()">VIALIDAD</mat-checkbox>
                                </div>
                                <div class="col-md-2"></div>
                                <div class="col-md-10" *ngIf="encontrado != '4.5'">
                                    <mat-checkbox  [(ngModel)]="tipo_garantia['PARQUE']" value="4" (change)="add_caract_sol()">PARQUE</mat-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
</div>